var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "message-input-container" }, [
    _c("div", { staticClass: "message-input-form" }, [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.messageToSend,
            expression: "messageToSend",
          },
        ],
        staticClass: "message-textarea",
        attrs: {
          id: "message-input",
          placeholder: _vm.$t("chatBot.placeholder"),
        },
        domProps: { value: _vm.messageToSend },
        on: {
          keypress: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.handleTextAreaEnter.apply(null, arguments)
          },
          input: function ($event) {
            if ($event.target.composing) return
            _vm.messageToSend = $event.target.value
          },
        },
      }),
    ]),
    _c("div", { staticClass: "message-send" }, [
      _c("button", {
        staticClass: "message-send-btn rounded-full",
        attrs: { disabled: _vm.isSendBtnDisabled },
        on: { click: _vm.handleSendBtnClick },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }